import { DatePickerInputProps, DatePickerInput } from '@mantine/dates';
import { IconChevronDown } from '@tabler/icons-react';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import AbsoluteError from 'components/ui/AbsoluteError';
import { FieldDateStore } from 'stores/local/shared/form/FieldDateStore';

type FieldDateProps = Omit<DatePickerInputProps, 'value' | 'onChange' | 'error'> & {
  store: FieldDateStore;
  fwInput?: string;
  icon?: React.ReactNode;
  minDate?: Date;
};

const FieldDate: React.FC<FieldDateProps> = ({ store, fwInput = 600, icon, minDate, ...props }) => {
  const onChange = React.useCallback(
    (v: Date | null) => {
      store.setValue(v);
      store.blur();
    },
    [store],
  );

  return (
    <DatePickerInput<'default'>
      clearable
      onFocus={store.focus}
      size="lg"
      valueFormat="DD.MM.YYYY"
      error={store.hasError && <AbsoluteError error={store.error} />}
      value={store.value}
      onChange={onChange}
      minDate={minDate}
      disabled={store.disabled}
      required={store.required}
      rightSectionPointerEvents={store.value ? undefined : 'none'}
      rightSection={store.value ? undefined : (icon ?? <IconChevronDown />)}
      styles={{
        input: {
          paddingLeft: 16,
          fontWeight: fwInput,
        },
      }}
      {...props}
    />
  );
};

export default observer(FieldDate);
